<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-flex md12>
            <material-card
                color="green"
                title="Class Summary"
                class="grid-card"
            >
                <v-layout row class="mt-2 mr-1">
                    <v-select
                        v-model="regID"
                        label="Term"
                        class="pl-3 width-250"
                        :items="terms"
                        hide-details
                        @change="onTermChanged"
                    ></v-select>
                    <v-select
                        v-model="gander"
                        label="Gander"
                        class="pl-3 width-250"
                        :items="['Boys', 'Girls']"
                        hide-details
                        @change="onGanderChanged"
                    ></v-select>
                    <v-spacer></v-spacer>
                    <download-excel
                        :fields="exportFields()"
                        :name="getExportFileName()"
                        :before-generate="() => (isExporting = true)"
                        :before-finish="() => (isExporting = false)"
                        :fetch="exportToExcel"
                        type="xls"
                    >
                        <v-btn
                            small
                            icon
                            :loading="isExporting"
                            class="mt-1 py-0"
                            ><v-icon color="success"
                                >mdi-file-export</v-icon
                            ></v-btn
                        >
                    </download-excel>

                    <v-btn-toggle
                        class="toggle-button-group"
                        mandatory
                        v-model="showClasses"
                    >
                        <v-btn class="toggle-button" flat v-bind:value="false">
                            Hide Classes
                        </v-btn>
                        <v-btn class="toggle-button" flat v-bind:value="true">
                            Show Classes
                        </v-btn>
                    </v-btn-toggle>
                </v-layout>
                <vue-good-table
                    class="pt-3"
                    style="cursor: pointer;"
                    ref="table"
                    :columns="columns"
                    :rows="classSummary"
                    :groupOptions="{
                        enabled: true,
                        headerPosition: 'bottom',
                    }"
                    :search-options="{
                        enabled: false,
                    }"
                >
                    <template slot="table-header-row" slot-scope="props">
                        <div
                            @click="
                                openPrintClassListDialog(
                                    props.row,
                                    props.column,
                                )
                            "
                        >
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <div
                            @click="
                                openPrintClassListDialog(
                                    props.row,
                                    props.column,
                                )
                            "
                        >
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                </vue-good-table>
            </material-card>
        </v-flex>
        <v-dialog v-model="printClassListDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Print Class List</v-card-title>
                <v-card-text class="mb-2">
                    <v-layout row class="mb-2" v-if="printClassDialog.grade">
                        <div class="font-weight-medium mr-2">
                            Grade:
                        </div>
                        <div>
                            {{ printClassDialog.grade }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2" v-if="printClassDialog.teacher">
                        <div class="font-weight-medium mr-2">
                            Teacher:
                        </div>
                        <div>
                            {{ printClassDialog.teacher }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2" v-if="printClassDialog.week">
                        <div class="font-weight-medium mr-2">
                            Week:
                        </div>
                        <div>
                            {{ printClassDialog.week }}
                        </div>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closePrintClassDialog" dark color="default"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="printClassList">
                        Print Class List
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { pluralize, sum } from "../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        classSummary: [],
        printClassListDialog: false,
        printForClass: "",
        classes: [],
        showClasses: true,
        regID: "",
        gander: "Boys",
        terms: [],
        isExporting: false,

        printClassDialog: {
            classID: "",
            teacher: "",
            week: "",
            grade: "",
            weekDisplay: "",
        },

        columns: [
            {
                sortable: false,
                label: "Grade",
                field: "class",
                width: "200px",
                hidden: false,
            },
            {
                sortable: false,
                label: "Teacher",
                field: "teacher",
                width: "200px",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 1",
                field: "week1",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 2",
                field: "week2",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 3",
                field: "week3",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 4",
                field: "week4",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 5",
                field: "week5",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 6",
                field: "week6",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 7",
                field: "week7",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 8",
                field: "week8",
                width: "100px",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Week 9",
                field: "week9",
                width: "100px",
                type: "Number",
                hidden: false,
            },
        ],
    }),
    watch: {
        showClasses(newValue, oldValue) {
            this.classSummary
                .map((c) => c.children)
                .forEach((grade) =>
                    grade.forEach((row) => {
                        if (!row.teacher) return;

                        row.hidden = !newValue;
                    }),
                );
        },
    },
    async created() {
        await this.loadRegID();

        this.gander = localStorage.getItem("lapidus-class-summary-gander");

        this.loadData();
        this.loadTerms();
    },
    methods: {
        async loadData() {
            localStorage.setItem("lapidus-class-summary-gander", this.gander);

            const response = await this.$http.get(
                "api/lapidusDayCamp/GetClassSummary?setting=" + this.regID,
            );

            const classSummary = response
                .filter((c) => {
                    return this.gander == "Boys"
                        ? c.class.startsWith("B")
                        : c.class.startsWith("G");
                })
                .map((grades) => {
                    grades.children.forEach((c) => (c.hidden = false));

                    grades.class =
                        grades.class +
                        ` Total (${grades.children.length} ${pluralize(
                            "Class",
                            grades.children.length,
                        )})`;
                    return grades;
                });

            classSummary.push({
                class: "Grand Total",
                teacher: "",
                week1: sum(classSummary.map((c) => c.week1)),
                week2: sum(classSummary.map((c) => c.week2)),
                week3: sum(classSummary.map((c) => c.week3)),
                week4: sum(classSummary.map((c) => c.week4)),
                week5: sum(classSummary.map((c) => c.week5)),
                week6: sum(classSummary.map((c) => c.week6)),
                week7: sum(classSummary.map((c) => c.week7)),
                week8: sum(classSummary.map((c) => c.week8)),
                week9: sum(classSummary.map((c) => c.week9)),
                children: [
                    {
                        hidden: true,
                        class: "",
                        teacher: "",
                        week1: 1,
                        week2: 1,
                        week3: 1,
                        week4: 1,
                        week5: 1,
                        week6: 1,
                        week7: 1,
                        week8: 1,
                        week9: 1,
                    },
                ],
            });

            this.classSummary = classSummary;

            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID,
            );

            this.classes = classes;
        },
        onTermChanged(value) {
            this.loadData();
        },
        onGanderChanged(value) {
            this.loadData();
        },
        async loadTerms() {
            const response = await this.$http.get(
                "api/lapidusDayCamp/getRegTerms",
            );

            this.terms = response.map((r) => r.term);
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        openPrintClassListDialog(row, column) {
            this.printClassDialog.teacher = row["teacher"];
            this.printClassDialog.grade =
                row["class"].split(" ")[0] != "Grand"
                    ? row["class"].split(" ")[0]
                    : "";
            this.printClassDialog.classID = row["classID"]
                ? row["classID"]
                : undefined;
            this.printClassDialog.week = column.field.startsWith("week")
                ? column.field.substring(4)
                : "";

            this.printClassListDialog = true;
        },
        closePrintClassDialog() {
            this.printClassListDialog = false;

            this.printClassDialog.teacher = "";
            this.printClassDialog.grade = "";
            this.printClassDialog.classID = "";
            this.printClassDialog.week = "";
            this.printClassDialog.weekDisplay = "";
        },
        async printClassList() {
            await this.printList();

            this.closePrintClassDialog();
        },
        async printList() {
            const students = (await this.loadStudents()).value;

            var myWindow = window.open(
                "",
                "Class List",
                "width=1200, height=1200",
            );

            myWindow.document.write(this.createClassListHtml(students));
        },
        loadStudents() {
            const filter = this.getFilter()
                ? `$filter=${this.getFilter()}`
                : "";

            return this.$http.get(`odata/lapidusStudents?${filter}`);
        },
        getFilter() {
            const { classID, grade, week } = this.printClassDialog;

            const filters = [];

            if (classID != null && classID !== undefined) {
                filters.push(`classID eq ${classID}`);
            }

            if (grade) {
                filters.push(`lapidusGrade eq '${grade}'`);
            }

            if (week) {
                filters.push(`contains(weeks, '${week}')`);
            }

            return `${filters.join(" and ")}`;
        },
        createClassListHtml(students) {
            const showClass = students.some(
                (s) => s.class != students[0].class,
            );

            let html = `<head>
                        <style>
                        table {
                          font-family: arial, sans-serif;
                          border-collapse: collapse;
                          width: 100%;
                        }

                        .nice-text {
                            font-family: arial, sans-serif;
                        }

                        td, th {
                          border: 1px solid #dddddd;
                          text-align: left;
                          padding: 8px;
                        }

                        tr:nth-child(even) {
                          background-color: #dddddd;
                        }

                        .right-align {
                text-align: right;
            }
                        </style>
                        </head>`;

            html += `<p class="nice-text right-align">${moment().format(
                "LLL",
            )}</p>`;

            const firstStudentClass = this.classes.find(
                (c) => c.classID == students[0].classID,
            );

            const classTitle =
                firstStudentClass.grade + " - " + firstStudentClass.teacher;

            html += showClass
                ? `<h2 class="nice-text">Class List</h2>`
                : `<h2 class="nice-text">Class List - ${classTitle}</h2>`;

            html += `<table>
                            <tr>
                            <th>Name</th>
                            <th class="right-align">Hebrew Name</th>
                            <th class="right-align">Father</th>
                          `;

            if (showClass) {
                html += `<th>Class</th>`;
            }

            html += `
                            <th>Weeks</th>
                            <th>Country</th>`;

            html += "</tr>";

            students
                .map((student) => {
                    let data = {
                        name: student.name,
                        hebName: student.hName,
                        fatherH: student.fatherH,
                    };

                    if (showClass) {
                        data.class = student.class;
                    }
                    data.weeks = student.weeks;
                    data.country = student.country;

                    return data;
                })
                .forEach((student) => {
                    html += `<tr>`;

                    Object.entries(student).forEach((v) => {
                        const field = v[0];
                        const value = v[1];

                        html += ["hebName", "fatherH"].includes(field)
                            ? `<td class="right-align">${value}</td>`
                            : `<td>${value}</td>`;
                    });

                    html += `</tr>`;
                });

            html += `</table>`;

            return html;
        },
        showRow(row) {
            return row.class;
        },
        getExportFileName() {
            return "Class Summary - " + moment().format("L");
        },

        exportFields() {
            let fields = {};

            this.columns.forEach((column) => {
                if (column.hidden) return;

                fields[column.label] = column.field;
            });

            return fields;
        },

        async exportToExcel() {
            return this.classSummary;
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}
.v-btn__content {
    color: unset;
}
</style>
